<template>
  <div id="page-user-list">
    <vx-card
      title="FMCSA Reports"
      class="vx-card p-6"
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow"></div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
        <vs-button class="mb-4 md:mb-0" @click="openPopUp = true"
          >Send New Report
        </vs-button>

        <!-- DRIVER SELECTION DIALOG -->
        <vs-prompt
          :active.sync="openPopUp"
          accept-text="Send"
          cancel-text="Cancel"
          title="New FMCSA Report"
        >
          <div class="content">
            <vs-row vs-w="12">
              <vs-col class="mb-5" type="flex" vs-w="12">
                <vs-input
                  class="full-width"
                  label="Safety Official/Investigation Code*"
                  v-model="dialogForm.code"
                  style="width: 100%"
                />
              </vs-col>
              <vs-col type="flex" vs-w="12">
                <vs-select
                  placeholder="Select Driver"
                  autocomplete
                  class="selectExample"
                  label="Drivers"
                  v-model="dialogForm.drivers"
                  width="100%"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in options1"
                  />
                </vs-select>
              </vs-col>
              <vs-col class="mt-5" vs-w="12">
                <vs-dropdown
                  class="dropdown"
                  vs-custom-content
                  vs-trigger-click
                >
                  <div class="dropdown-content">
                    <span
                      v-if="isSameDay(dialogForm.dateRange.end, new Date())"
                    >
                      Last
                    </span>
                    {{ daysInterval }} days ({{
                      $dayjs(dialogForm.dateRange.start).format("DD-MM-YYYY")
                    }}) ({{
                      $dayjs(dialogForm.dateRange.end).format("DD-MM-YYYY")
                    }})
                  </div>
                  <vs-dropdown-menu ref="dropdownMenu" class="dropdown-wrapper">
                    <div class="dropdown-menu">
                      <div class="dropdown-body">
                        <div class="dropdown-actions">
                          <vs-button
                            :class="[
                              'dropdown-actions__btn',
                              { active: !isRange },
                            ]"
                            color="danger"
                            type="border"
                            @click="setWeekValue"
                            >Last 8 days</vs-button
                          >
                          <vs-button
                            :class="[
                              'dropdown-actions__btn',
                              { active: isRange },
                            ]"
                            color="danger"
                            type="border"
                            @click="setRangeValue"
                            >Custom Range</vs-button
                          >
                        </div>
                        <v-date-picker
                          v-model="dialogForm.dateRange"
                          :columns="2"
                          :max-date="new Date()"
                          is-range
                          @input="checkValue"
                        />
                      </div>
                    </div>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-col>
            </vs-row>
          </div>
        </vs-prompt>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table full-width-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
// Cell Renderer
import CellRendererLink from "@/components/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "@/components/cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "@/components/cell-renderer/CellRendererActions.vue";

// import VxCard from '../../components/vx-card/VxCard.vue'

export default {
  name: "transfer",
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      searchQuery: "",
      selectDrivers: [],
      options1: [
        { text: "Nusrat", value: 0 },
        { text: "Ahmed Abdulla", value: 2 },
        { text: "Mehmet Elyor", value: 3 },
      ],

      // Dialog
      openPopUp: false,
      dialogForm: {
        code: "",
        drivers: null,
        dateRange: {
          start: this.oneWeek(),
          end: new Date(),
        },
      },

      //V-calendar
      isRange: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "ID",
          field: "vehicleid",
          width: 100,
          filter: true,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
        },
        {
          headerName: "Origin",
          field: "notes",
          filter: true,
          width: 150,
        },
        {
          headerName: "File Code",
          field: "code",
          width: 150,
          //   cellRendererFramework: 'CellRendererActions',
          //   cellClass: 'text-center'
        },
        {
          headerName: "Driver and Time Range",
          field: "notes",
          width: 250,
          //   cellRendererFramework: 'CellRendererActions',
          //   cellClass: 'text-center'
        },
        {
          headerName: "Created Time",
          field: "created",
          width: 150,
          //   cellRendererFramework: 'CellRendererActions',
          //   cellClass: 'text-center'
        },
        {
          headerName: "Status",
          field: "status",
          width: 150,
          //   cellRendererFramework: 'CellRendererActions',
          //   cellClass: 'text-center'
        },
        {
          headerName: "Processed Time",
          field: "time",
          width: 250,
          //   cellRendererFramework: 'CellRendererActions',
          //   cellClass: 'text-center'
        },
        {
          headerName: "Submission ID",
          field: "id",
          width: 250,
          //   cellRendererFramework: 'CellRendererActions'
          //   cellClass: 'text-center'
        },
      ],

      usersData: [
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
        {
          code: "4567-gsdg9",
          notes: "Elon Musk",
          status: "Active",
          time: "36 hours",
          created: "48 hours",
          id: "435678976",
          filter: true,
          width: 150,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  computed: {
    usersData() {
      return this.$store.state.moduleManagmentList.users;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    daysInterval() {
      const interval =
        this.dialogForm.dateRange.end.getTime() -
        this.dialogForm.dateRange.start.getTime();
      return Math.ceil(interval / 1000 / 60 / 60 / 24);
    },
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
    },
    oneWeek() {
      const today = new Date();

      const nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 7
      );
      return nextweek;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          { label: "All", value: "all" };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    isSameDay(firstDate, secondDate) {
      if (
        firstDate.getFullYear() === secondDate.getFullYear() &&
        firstDate.getMonth() === secondDate.getMonth() &&
        firstDate.getDate() === secondDate.getDate()
      ) {
        return true;
      }

      return false;
    },
    setWeekValue() {
      this.dialogForm.dateRange = {
        start: this.oneWeek(),
        end: new Date(),
      };

      this.isRange = false;
    },
    setRangeValue() {
      this.isRange = true;
    },
    checkValue({ start, end }) {
      if (
        this.isSameDay(start, this.oneWeek()) &&
        this.isSameDay(end, new Date())
      ) {
        this.isRange = false;
      } else {
        this.isRange = true;
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
};
</script>

<style lang="scss">
.user-list-filters {
  .vs__actions {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-58%);
  }
}
.menu-wrapper {
  display: flex;
  .select-button {
    white-space: nowrap;
  }
}

.calendar-buttons-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.dropdown {
  &-wrapper {
    z-index: 52010;
  }

  &-menu {
    display: flex;
    flex-direction: column;
  }

  &-body {
    display: flex;
    gap: 20px;
  }

  &-actions {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &__btn {
      white-space: nowrap;

      &.active {
        background: rgba(var(--vs-danger), 1) !important;

        .vs-button-text {
          color: white !important;
        }
      }
    }
  }
}
</style>
